import { TRANSLATION_API } from "../constants/api";
import { getHeaders, getUrl, optionsGet } from "./commonService";
import customAxios from "./customAxios";


export default class TranslationsService {

  getTranslationsService(tenantName: string, language: string) {

    let api = TRANSLATION_API.LIST;
    api = api.replace("#LANG#", language);

    const url = getUrl(api);
    const headers = getHeaders(tenantName);
    const options: any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });


  }
}
